import { dispatch } from 'app/store';
export default function CloseModal() {
  dispatch({
    type: 'CLOSE_MODAL',
  });
}
